/**
 * 選択されたproductの情報を格納する
 */
const product = {
  namespaced: true,
  state: {
    /**
     * 一覧に表示するために選択されたアイテムのjan_codeの配列
     */
    selectedProductIds: [
      // "4901872674015",
      // "4514254662540",
      // "4514254662557",
      // "4901872064557",
      // "4901872099528",
      // "4909978995683",
    ], //janCodeIds

    /**
     * 一覧ページで固定表示するアイテムのjan_code
     */
    fixedId: "", //jancodeId

    /**
     * review取得APIから取得したデータのキャッシュ
     */
    review: [], //例） { poolId: "", totalCount: "123", totalEvaluation: 4.5 }
  },
  mutations: {
    setSelectedProductIds(state, payload) {
      const { value } = payload;
      state.selectedProductIds = value;
    },
    removeSelectedProductIds(state, payload) {
      const { value } = payload;
      const currentIds = state.selectedProductIds;
      const index = currentIds.indexOf(value);
      if (index !== -1) state.selectedProductIds.splice(index, 1);
    },
    setReviewData(state, payload) {
      const reviewArray = state.review;
      const { poolId, totalCount, totalEvaluation } = payload;
      reviewArray.push({ poolId, totalCount, totalEvaluation });
    },
    setFixedId(state, payload) {
      const id = payload.id ?? "";
      state.fixedId = id;
    },
  },
  actions: {
    setSelectedProductIds: ({ commit }, payload) => {
      commit("setSelectedProductIds", payload);
    },
    removeSelectedProductIds: ({ commit }, payload) => {
      commit("removeSelectedProductIds", payload);
    },
    setReviewData: ({ commit }, payload) => {
      commit("setReviewData", payload);
    },
    setFixedId: ({ commit }, payload) => {
      commit("setFixedId", payload);
    },
  },
  getters: {
    product(state) {
      return state;
    },
    review(state) {
      return state.review;
    },
    selectedProductIds(state) {
      return state.selectedProductIds;
    },
    fixedId(state) {
      return state.fixedId;
    },
  },
};

export default product;
